import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Envelope, Password } from '@phosphor-icons/react'
import './style.css'
import { ON_LOGIN } from '../graphql/mutation';
import { useMutation } from '@apollo/client';

export default function Login() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const [login, { loading }] = useMutation(ON_LOGIN)

  const onLogin = () => {
    if (email && password) {
      login({
        variables: {
          "user": {
            "email": email,
            "password": password
          }
        }
      }).then((e) => {
        localStorage.setItem('xand_user', e?.data?.onLogin)
        setTimeout(() => {
          window.location.reload()
        }, 500);
      }).catch((err)=>{
        console.log(err?.message);
      })
    }
  }

  return (
    <div className='Login'>
      <div className='Login_Con'>
        <form onSubmit={(e) => {
          e?.preventDefault()
          onLogin()
        }}>
          <h1>XAND</h1>
          <h2>Login to your account</h2>
          <div className='Login_Con_Input'>
            <div className='Login_Con_Input_Icon'>
              <Envelope />
            </div>
            <input value={email} onChange={(e) => setEmail(e?.target?.value)} placeholder='Email' />
          </div>
          <div className='Login_Con_Input'>
            <div className='Login_Con_Input_Icon'>
              <Password />
            </div>
            <input type='password' value={password} onChange={(e) => setPassword(e?.target?.value)} placeholder='Password' />
          </div>
          <button>{loading ? "Please wait" : "Login"}</button>
        </form>
        <p>Don't have an account? <Link to={'/signup'}>Signup</Link></p>
      </div>
    </div>
  )
}
